import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/shared/components/Navbar';
import Footer from '@/shared/components/Footer';

import {
  Compliance,
  Hero,
  Platform,
  Security,
  TechnologyCarousel
} from './Components';
import { LogoCarousel } from './Components/LogoCarousel';
import { scrollToSection } from './HomeUtils';

type HomeLocationState = {
  scrollToSection?: string;
};

const HomePage = () => {
  const location = useLocation();
  const routeState = location.state as HomeLocationState | null;
  const targetSection =
    typeof routeState?.scrollToSection === 'string'
      ? routeState.scrollToSection
      : null;

  useEffect(() => {
    if (targetSection === null) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      scrollToSection(targetSection);
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [location.key, targetSection]);

  return (
    <div className="min-h-screen bg-background-primary text-text-primary antialiased">
      <Navbar />

      <main className="overflow-visible">
        <Hero />
        <LogoCarousel />
        {/* <InspiraSavings /> */}
        <TechnologyCarousel />
        <Platform />
        <Compliance />
        {/* <BuildVsBuy /> */}
        {/* <Calculator /> */}
        <Security />
      </main>

      <Footer />
    </div>
  );
};

export default HomePage;
